import { createTheme, CssBaseline, ThemeProvider, useTheme } from "@mui/material"
import React, { useContext, useEffect } from "react"
import { useParams } from "react-router-dom"
import { customPalette } from "../../../../../../../../theme"
import { IconInbox } from "../../../../../../../components/custom-icons/icon-inbox"
import { TabEnum } from "../../../../../../../components/tabs/tabs"
import { pagesUrl } from "../../../../../../../core/appConstants"
import { BSVariantContext } from "../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../../../core/context/project/CoverImgProjectContext"
import { resolveUrl } from "../../../../../../../core/services/http-service"
import { BSBuildingContext } from "../components/context/BSBuildingContext"
import { BSCalculationForm } from "./BSCalculationForm/BSCalculationForm"

interface IProps {
  isBeemShot?: boolean
  isBeemMorphology?: boolean
}

export function BSCalculationPage({ isBeemMorphology, isBeemShot }: Readonly<IProps>): React.JSX.Element {
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)

  const { projectId, bsVariantId } = useParams()

  const theme = useTheme()
  const modifiedTheme = createTheme({
    ...theme,
    palette: {
      ...theme.palette,
      background: {
        ...theme.palette.background,
        default: customPalette.white,
        paper: customPalette.white,
      },
    },
  })

  useEffect(() => {
    setTypeNavBar(NavbarTypeEnum.BUILDING_CALCUL)
    setPreviousUrl(
      resolveUrl(pagesUrl.VARIANT_DETAILS, [projectId, bsVariantId], {
        bsBuildingId: selectedBSBuilding?.id,
        tab: TabEnum.BUILDING_INFO,
      })
    )
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
  }, [
    projectId,
    bsVariantId,
    setPreviousUrl,
    setTypeNavBar,
    setImageFile,
    file,
    setIcon,
    setTitle,
    selectedVariant?.name,
    selectedBSBuilding?.id,
  ])

  return (
    <ThemeProvider theme={modifiedTheme}>
      <CssBaseline />
      <BSCalculationForm isBeemMorphology={isBeemMorphology} isBeemShot={isBeemShot} />
    </ThemeProvider>
  )
}
